
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoaurangabadinnovacrystacabservice() {



    const cardData =
    {
        keyword: 'Pune Aurangabad Innova Crysta Cab Service',
        heading: 'Meghana Cab : Pune Aurangabad Innova Crysta Cab Service',
        headingDescription: 'Meghana Cab offers Pune Aurangabad Innova Crysta Cab Service, specially designed for travelers seeking comfort, convenience, and luxury on long-distance journeys. Whether you are heading to Aurangabad for business meetings, sightseeing at Ajanta & Ellora caves, or a family trip, our Innova Crysta vehicles provide a spacious and premium travel experience. With plush leather interiors, generous legroom, and ample luggage capacity, our cars ensure a relaxing ride throughout the journey. Enjoy door-to-door pickup from anywhere in Pune, professional and courteous chauffeurs experienced with the Pune–Aurangabad route, GPS tracking, and transparent fixed fares (one-way, round-trip, or per kilometer packages). With Meghana Cab’s 24/7 customer support and hassle-free booking, your Pune to Aurangabad Innova Crysta Cab promises a smooth, stylish, and dependable travel experience.',


        top: 'Top Places to Visit in Aurangabad with Meghana Cab',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "A UNESCO World Heritage Site located about 100 km from Aurangabad, the Ajanta Caves comprise 30 rock-cut Buddhist cave monuments carved between the 2nd century BCE and 6th century CE. These caves feature intricate murals, sculptures, chaityas (prayer halls), and viharas (monasteries) that depict the life of Buddha and Jataka tales. The paintings, made with natural dyes, are celebrated worldwide for their detail, emotion, and spiritual depth. Set in a horseshoe-shaped cliff overlooking the Waghora River, the caves offer not only artistic grandeur but also scenic tranquility."
  },
  {
    "title": "Ellora Caves",
    "description": "Just 30 km from Aurangabad, the Ellora Caves are another UNESCO World Heritage Site showcasing a harmonious blend of Hindu, Buddhist, and Jain cultures. The site has 34 caves carved between the 6th and 10th centuries CE. The most famous is Cave 16—the Kailasa Temple—a massive monolithic structure representing Mount Kailash, carved from a single rock. The site reflects India’s religious tolerance and artistic zenith, with intricately sculpted deities, monks’ cells, and spiritual symbols across the caves."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Often referred to as the 'Taj of the Deccan', Bibi Ka Maqbara was built in the 17th century by Aurangzeb’s son Azam Shah in memory of his mother Dilras Banu Begum. This marble-clad mausoleum resembles the Taj Mahal in design and grandeur but with Deccan-style variations. Set amidst beautifully laid Mughal gardens with fountains, pathways, and water channels, it offers an architectural retreat steeped in Mughal elegance. It’s especially enchanting during golden hour photography sessions and moonlit evenings."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Located 16 km from Aurangabad, Daulatabad Fort (formerly Devagiri Fort) is an impregnable hilltop fortress known for its military design and 200-meter-high conical hill base. Built in the 12th century, it has complex defense mechanisms including spiked doors, dark passageways, and moats with crocodiles. Once the capital of India under Sultan Muhammad bin Tughlaq, the fort now stands as a powerful reminder of medieval engineering, with panoramic views from its summit that attract history buffs, photographers, and trekkers alike."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Less visited but equally fascinating, the Aurangabad Caves are a group of 12 rock-cut Buddhist shrines carved into the hills near Bibi Ka Maqbara. Dating back to the 6th and 7th centuries, these caves showcase intricate sculptures of bodhisattvas, tantric deities, and celestial beings. The highlight is Cave 7, known for its elaborate carvings and Goddess Tara. With fewer crowds and scenic views of the city, these caves provide a peaceful alternative to the more popular Ajanta and Ellora."
  },
  {
    "title": "Panchakki (Water Mill)",
    "description": "Panchakki is a 17th-century water mill complex that served both religious and practical purposes for a nearby Sufi shrine. It was ingeniously designed to use a hidden underground water channel to turn a grinding stone, supplying flour to pilgrims and the dargah kitchen. Surrounded by a garden, mosque, and tombs, the Panchakki is a remarkable example of medieval engineering and spiritual hospitality. The tranquil site is also a spot for quiet reflection and Sufi reverence."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Located near the Ellora Caves, Grishneshwar Temple is one of the 12 Jyotirlingas of Lord Shiva and the holiest temple in the Aurangabad region. Built in traditional South Indian style, the temple’s red-stone architecture, five-tier shikhara, and carved walls attract thousands of devotees daily. The spiritual energy, combined with its proximity to Ellora, makes it a must-visit for pilgrims and cultural travelers alike. Photography is restricted inside, preserving its sacred atmosphere."
  },
  {
    "title": "Salim Ali Lake & Bird Sanctuary",
    "description": "Named after the famous ornithologist Dr. Salim Ali, this lake and bird sanctuary is located near Delhi Gate in Aurangabad. It serves as a natural retreat in the heart of the city and is home to both migratory and resident bird species. A paved walking path, boating facilities, and shaded picnic areas make it ideal for families and nature lovers. The sanctuary offers bird-watching opportunities, especially during the winter season when migratory birds flock in."
  },
  {
    "title": "Siddharth Garden & Zoo",
    "description": "Situated near the central railway station, Siddharth Garden is a well-maintained public garden with a modest but engaging zoo. It's a family-friendly attraction that features landscaped lawns, fountains, flowering plants, and animal enclosures with tigers, crocodiles, and various bird species. It’s especially popular among children and school groups. The garden also has a large statue of Dr. Babasaheb Ambedkar and offers a relaxing break for locals and tourists alike."
  },
  {
    "title": "Himayat Bagh",
    "description": "Himayat Bagh, or 'Garden of Himayat', is a sprawling 300-acre Mughal-style garden near Delhi Gate. Originally built as a royal orchard during the Mughal period, it now houses a government fruit research center and nursery. The lush gardens, ancient aqueducts, and heritage walls make it an offbeat, tranquil destination perfect for walking, botany enthusiasts, or anyone looking to escape the bustle of the city amidst history-laced nature."
  }
],

"services": [
  {
    "name": "Pune to Aurangabad Innova Crysta Cab Booking",
    "description": "Book your Pune to Aurangabad Innova Crysta cab for a comfortable and reliable journey. Whether traveling for business or leisure, enjoy spacious seating, ample luggage capacity, and professional chauffeurs committed to providing a smooth and safe ride."
  },
  {
    "name": "One Way Innova Crysta Pune Aurangabad",
    "description": "Travel hassle-free with our one-way Innova Crysta taxi service from Pune to Aurangabad. Ideal for solo travelers, families, or groups, this service guarantees timely pickups, air-conditioned comfort, and a relaxing journey."
  },
  {
    "name": "Round Trip Innova Crysta Pune Aurangabad",
    "description": "Plan your round trip between Pune and Aurangabad with our dependable Innova Crysta cab service. Enjoy flexible scheduling, premium comfort, and experienced chauffeurs ensuring a stress-free and pleasant travel experience."
  },
  {
    "name": "AC Innova Crysta Taxi Pune Aurangabad",
    "description": "Stay cool and comfortable on your Pune to Aurangabad trip with our fully air-conditioned Innova Crysta taxi. With plush interiors and climate control, this service offers a refreshing and comfortable ride regardless of the weather."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune to Aurangabad",
    "description": "Relax as our professional chauffeurs drive you safely from Pune to Aurangabad in a premium Innova Crysta. Prioritizing punctuality, safety, and courteous service, we ensure your journey is smooth and enjoyable."
  },
  {
    "name": "Budget Innova Crysta Cab Pune Aurangabad",
    "description": "Experience affordable yet comfortable travel with our budget-friendly Innova Crysta cab service from Pune to Aurangabad. Perfect for travelers seeking value without compromising on quality and reliability."
  },
  {
    "name": "Online Booking Innova Crysta Pune Aurangabad",
    "description": "Easily book your Pune to Aurangabad Innova Crysta taxi online. Our secure and user-friendly platform offers instant confirmation, flexible timing options, and transparent pricing for a hassle-free booking experience."
  },
  {
    "name": "Private Innova Crysta Taxi Pune Aurangabad",
    "description": "Enjoy exclusive travel with our private Innova Crysta taxi service from Pune to Aurangabad. Ideal for VIPs or groups desiring privacy, this service provides dedicated vehicles and personalized attention for a comfortable journey."
  }
],
"tableData": [
  ["Pune to Aurangabad Innova Crysta Cab Booking", "One Way Innova Crysta Pune Aurangabad"],
  ["Round Trip Innova Crysta Pune Aurangabad", "AC Innova Crysta Taxi Pune Aurangabad"],
  ["Chauffeur Driven Innova Crysta Pune to Aurangabad", "Budget Innova Crysta Cab Pune Aurangabad"],
  ["Online Booking Innova Crysta Pune Aurangabad", "Private Innova Crysta Taxi Pune Aurangabad"]
],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Aurangabad Innova Crysta Cab Service",
        "WhyChoosedescription": "Travel from Pune to Aurangabad in a premium Innova Crysta cab that offers the perfect mix of comfort, space, and reliability. Ideal for family trips, business visits, and sightseeing tours to heritage destinations like Ajanta and Ellora Caves."
    },
    {
        "WhyChooseheading": "Spacious and Feature-Rich Vehicle for Long Routes",
        "WhyChoosedescription": "The Innova Crysta is designed for long-distance comfort, with reclining seats, ample legroom, rear AC vents, and luggage space—ideal for 6–7 passengers traveling together over the 230+ km stretch from Pune to Aurangabad."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Excellent Route Knowledge",
        "WhyChoosedescription": "Our trained and courteous drivers are well-versed with the Pune–Aurangabad highway and alternate routes. They ensure a safe, efficient journey and can also assist with stopovers at points of interest or food breaks along the way."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Cabs",
        "WhyChoosedescription": "Every Innova Crysta undergoes regular servicing and complete sanitization before your ride. You’ll enjoy a neat, odor-free, and hygienic travel environment from start to finish."
    },
    {
        "WhyChooseheading": "Customizable Travel Plans and Flexible Scheduling",
        "WhyChoosedescription": "Whether you're booking a one-way drop, same-day return, or a multi-day round trip, we offer flexible rental options tailored to your needs. Customize pickup/drop locations and stopovers for maximum convenience."
    },
    {
        "WhyChooseheading": "Transparent, All-Inclusive Pricing",
        "WhyChoosedescription": "Our Pune to Aurangabad Innova Crysta fares include tolls, driver charges, fuel, and taxes—no hidden costs or last-minute surprises. Get premium service at honest, competitive rates."
    },
    {
        "WhyChooseheading": "Ideal for Sightseeing, Business Travel, and Family Trips",
        "WhyChoosedescription": "Whether you're visiting UNESCO sites like Ellora Caves, attending a business meeting, or taking your family on a weekend getaway, our Innova Crysta cab ensures a smooth and pleasant travel experience."
    },
    {
        "WhyChooseheading": "24/7 Booking and Travel Assistance",
        "WhyChoosedescription": "Book your cab online or by phone anytime. Our dedicated customer support team is available 24/7 to help with bookings, rescheduling, and special travel requests to make your journey seamless."
    }
]






















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Aurangabad?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or through our website for an easy and quick booking process."
    },
    {
        question: "What is the distance and travel time between Pune and Aurangabad?",
        answer: "The distance is around 235 km and the travel time typically ranges between 5 to 6 hours, depending on road conditions."
    },
    {
        question: "Is Innova Crysta suitable for long trips like Pune to Aurangabad?",
        answer: "Yes, the Innova Crysta is ideal for long-distance journeys, offering excellent comfort, space, and stability."
    },
    {
        question: "Can I book an Innova Crysta for a one-way or round trip?",
        answer: "Yes, we provide both one-way and round-trip options to meet your travel requirements."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The vehicle seats up to 6 or 7 passengers comfortably with adequate luggage space."
    },
    {
        question: "Is the Pune to Aurangabad Innova Crysta cab service available 24/7?",
        answer: "Yes, we offer 24/7 cab services so you can travel at your convenience, anytime."
    },
    {
        question: "Are the vehicles sanitized before every ride?",
        answer: "Yes, all our cabs are thoroughly cleaned and sanitized before every journey to ensure passenger safety."
    },
    {
        question: "Do the drivers have experience with the Pune–Aurangabad route?",
        answer: "Yes, our drivers are experienced, polite, and well-acquainted with the Pune–Aurangabad route."
    },
    {
        question: "What’s included in the fare for this cab service?",
        answer: "The fare includes fuel, driver charges, and tolls. Extra charges may apply for waiting time or parking if required."
    },
    {
        question: "What are the payment options for booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for your convenience."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Harshal More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience with Meghana Cab on our Pune to Aurangabad trip. Innova Crysta was spacious and very comfortable.”',
    },
    {
        name: 'Ms. Aarti Jagtap',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta cab service from Pune to Aurangabad was smooth, timely, and hassle-free. Highly recommended!”',
    },
];












































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const puneToAurangabadInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Aurangabad Innova Crysta Cab Service",
  "description": "Hire chauffeur-driven Innova Crysta SUV from Pune to Aurangabad for a comfortable and safe journey. Ideal for one-way, round trip, and private outstation travel. AC luxury travel at budget-friendly rates.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation SUV Cab Service",
  "areaServed": {
    "@type": "City",
    "name": "Aurangabad"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-aurangabad-innova-crysta-cab"
  }
};










    return (
        <div>
<Helmet>
  <title>Pune to Aurangabad Innova Crysta Cab | Book SUV Taxi Online</title>
  <meta
    name="description"
    content="Book AC Innova Crysta cab from Pune to Aurangabad for one-way or round trip travel. Chauffeur-driven SUV for family, private, or business travel. Online booking available."
  />
  <meta
    name="keywords"
    content="Pune to Aurangabad Innova Crysta Cab Booking, One Way Innova Crysta Pune Aurangabad, Round Trip Innova Crysta Pune Aurangabad, AC Innova Crysta Taxi Pune Aurangabad, Chauffeur Driven Innova Crysta Pune to Aurangabad, Budget Innova Crysta Cab Pune Aurangabad, Online Booking Innova Crysta Pune Aurangabad, Private Innova Crysta Taxi Pune Aurangabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToAurangabadInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoaurangabadinnovacrystacabservice;